import { auth, db } from "../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import UserAvatar from "./UserAvatar";
import { MessageType } from "../utils/types";
import { Trash } from "tabler-icons-react";
import { ActionIcon } from "@mantine/core";
import { deleteDoc, doc } from "firebase/firestore";

const Message = ({ message }: { message: MessageType }) => {
  const [user] = useAuthState(auth);

  async function deleteMessageHandle() {
    await deleteDoc(doc(db, "messages", message.id));
  }

  return (
    <div
      className={`chat-bubble ${
        message.senderId === user?.uid
          ? "chat-bubble--right"
          : "chat-bubble--left"
      }`}
    >
      <UserAvatar photoURL={message.avatar} size={35} name={message.name} />
      <div className="chat-bubble__content">
        <div className="user-name-message-time">
          <p className="user-name">{message.name}</p>
          {/* <p className="message-time">
            {new Date(message.createdAt).toLocaleDateString()}
          </p>
          <p className="message-time">
            {new Date(message.createdAt).toLocaleTimeString()}
          </p> */}
          <p className="message-time">
            {new Intl.DateTimeFormat("default", {
              year: "numeric",
              month: "numeric",
              day: "numeric",
            }).format(new Date(message.createdAt))}
          </p>
          <p className="message-time">
            {new Intl.DateTimeFormat("default", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: false,
            }).format(new Date(message.createdAt))}
          </p>
        </div>
        <p className="user-message">{message.text}</p>
      </div>
      {message.senderId === user?.uid && (
        <ActionIcon
          variant="transparent"
          style={{ marginLeft: "auto" }}
          onClick={deleteMessageHandle}
        >
          <Trash color="black" />
        </ActionIcon>
      )}
    </div>
  );
};

export default Message;
